type LogLevel = "debug" | "info" | "warn" | "error";

class Logger {
  private readonly isDevMode: boolean;

  constructor() {
    // Assuming 'development' is the dev mode identifier
    this.isDevMode = process.env.NODE_ENV === "development";
  }

  private log(level: LogLevel, ...args: any[]): void {
    if (level === "debug" && !this.isDevMode) {
      return; // Ignore debug logs unless in development mode
    }

    switch (level) {
      case "debug":
        console.debug(...args);
        break;
      case "info":
        console.info(...args);
        break;
      case "warn":
        console.warn(...args);
        break;
      case "error":
        console.error(...args);
        break;
      default:
        console.log(...args);
        break;
    }
  }

  public debug(...args: any[]): void {
    this.log("debug", ...args);
  }

  public info(...args: any[]): void {
    this.log("info", ...args);
  }

  public warn(...args: any[]): void {
    this.log("warn", ...args);
  }

  public error(...args: any[]): void {
    this.log("error", ...args);
  }
}

// Exporting a single instance of Logger
export const logger = new Logger();
